import styled from 'styled-components';
import { TextField } from '@mui/material';

export const UtilizationDistributionStyle = styled.div`
font-weight:700;
width:100px;
`;
export const UtilizationDistributionTextField=styled.div
`    .forminput{ border-radius: 50px;
        font-weight: 700;
        width:100px;
.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
    opacity: 1;
    color: black;
    background: #E4E4E4;
}

`